import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en.json";
import plTranslation from "./locales/pl.json";

// Pomocnicza funkcja do ręcznego fallbacku
const getInitialLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;

  console.log("🌍 Detected browser language:", browserLang);

  if (browserLang.startsWith("pl")) return "pl";
  if (browserLang.startsWith("en")) return "en";

  return "en"; // fallback
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      pl: { translation: plTranslation },
    },
    fallbackLng: "en",
    debug: false,

    detection: {
      // Kolejność wykrywania języka
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["strong", "br", "em", "ul", "li", "a"],
    },
  });

export default i18n;
